<p>widget-base works!</p>
